import { Button, Dialog, DialogActions, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import DropZone from "../../../commons/dropZone/DropZone";
import FormikTextField from "../../../commons/formik/FormikTextField";
import { StyledProgramaSeguridad } from "../../../styled/Obras";

const validationSchema = Yup.object().shape({
  cantidadFolios: Yup.number()
    .typeError("El campo Folios es obligatorio y debe ser mayor a 0")
    .required("El campo Folios es obligatorio y debe ser mayor a 0")
    .integer("El campo Folios debe ser un número entero")
    .min(1, "El campo Folios es obligatorio y debe ser mayor a 0")
    .max(99999, "Número demasiado alto"),
});

const ProgramaSeguridad = ({ denominacion, nroObra, open, handleClose, handleConfirm, file, setFile }) => {
  const postLoading = useSelector((state) => state.obra.adjuntarProgramaSeguridad.loading);

  const initialValues = {
    cantidadFolios: "",
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <StyledProgramaSeguridad.TitleContainer>Programa de Seguridad</StyledProgramaSeguridad.TitleContainer>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={(values) => handleConfirm(values)}
      >
        {({ submitForm }) => (
          <Form>
            <StyledProgramaSeguridad.DialogContent>
              <StyledProgramaSeguridad.ContentWrapper>
                <StyledProgramaSeguridad.TextBlock>
                  <StyledProgramaSeguridad.Title>
                    Nro de obra {nroObra} - {denominacion}
                  </StyledProgramaSeguridad.Title>
                  <StyledProgramaSeguridad.FoliosRow container spacing={2} alignItems="center">
                    <Grid item>
                      <Typography>Folios del Programa de Seguridad</Typography>
                    </Grid>
                    <Grid item>
                      <FormikTextField
                        name="cantidadFolios"
                        type="number"
                        inputProps={{ min: 1 }}
                        sx={{ width: 100 }}
                      />
                    </Grid>
                  </StyledProgramaSeguridad.FoliosRow>
                  <StyledProgramaSeguridad.Label>
                    Adjunte el programa de seguridad
                  </StyledProgramaSeguridad.Label>
                </StyledProgramaSeguridad.TextBlock>
                <DropZone
                  file={file}
                  setFile={setFile}
                  loading={false}
                  maxFiles={1}
                  extension=".PDF"
                  accept={{
                    "application/pdf": [".pdf"],
                  }}
                  dropZoneText="Arrastre aquí o haga click en el recuadro para importar información en formato PDF"
                />
              </StyledProgramaSeguridad.ContentWrapper>
            </StyledProgramaSeguridad.DialogContent>
            <DialogActions style={{ margin: 10 }}>
              <Button onClick={handleClose} disabled={postLoading} color="primary">
                Cancelar
              </Button>
              <Button onClick={submitForm} disabled={postLoading} color="primary" variant="contained">
                Aceptar
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ProgramaSeguridad;